<div class="job-progress">
  <div class="job-progress__status">
    <ng-container *ngIf="jobState">
      <span *ngIf="jobState.job.status == 0">The <strong>{{jobTitle}}</strong> job has not started yet.</span>
      <span *ngIf="jobState.job.status == 1">The <strong>{{jobTitle}}</strong> job is currently running.</span>
      <span *ngIf="jobState.job.status == 2">The <strong>{{jobTitle}}</strong> job has finished.</span>
      <span *ngIf="jobState.job.status == 3">The <strong>{{jobTitle}}</strong> job has failed.</span>
      <code *ngIf="jobState.job.status == 3" class="c-red-2 d-block overflow-auto max-h-200 mt-15">{{jobState.job.error}}</code>

      <ng-container *ngIf="jobState.state.getStateFailed">
        <br/>
        <p *ngIf="jobState.state.getStateFailed">
          <span>Failed to retrieve details about the <strong>{{jobTitle}}</strong> job.</span><br/>
          <span>This could be due to an issue with your network connection, or the job runner.</span>
        </p>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!jobState">
      <span>Loading details about the <strong>{{jobTitle}}</strong> job...</span>
    </ng-container>
  </div>
  <div *ngIf="!jobState || jobState.job.status == 1" class="job-progress__spinner mt-20">
    <app-spinner></app-spinner>
  </div>
</div>
